module.exports = __webpack_public_path__ + "static/img/banner-cursos-interior-1680x1050.88d86a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/@banners/@responsive/search-cursos/banner-cursos-interior-1680x1050.jpg
// module id = +m8X
// module chunks = 47